
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CxLanguagePicker',
  props: {
    availableLanguages: { type: Object, required: true }
  },
  emits: ['languageChanged'],
  computed: {
    translations(): Record<string, string> {
      return { language: this.$gettext('Language') };
    }
  },
});
